export const JOBALLOCATION_REQUEST = "JOBALLOCATION_REQUEST";
export const JOBALLOCATION_SUCCESS = "JOBALLOCATION_SUCCESS";
export const JOBALLOCATION_FAIL = "JOBALLOCATION_FAIL";

export const UNASSIGNLIST_REQUEST = "UNASSIGNLIST_REQUEST";
export const UNASSIGNLIST_SUCCESS = "UNASSIGNLIST_SUCCESS";
export const UNASSIGNLIST_FAIL = "UNASSIGNLIST_FAIL";

